export default __webpack_public_path__ + "static/media/ru.940d393e.svg";